//const BASE_URL = 'http://127.0.0.1:3001/';
const BASE_URL = 'https://future-mobility-backend.onrender.com/';
export default BASE_URL;
